import axios from "axios";
import { CONST } from "../config/const";

export interface ChatMessage {
  role: "user" | "assistant";
  content: string;
}

export async function postChatFeedback(
  id: number,
  feedback: 'good' | 'bad'
): Promise<void> {
  await axios.post(CONST.apiUrl2 + 'chatFeedback', { id, feedback });
}
